export default "__VITE_ASSET__DxhHUuLq__"